import {Fragment, useState} from 'react';
import { CreateButton, ExportButton, List, Show, useUpdate, Button, useRecordContext, Edit, FilterButton, useNotify, Create, required, ReferenceField } from 'react-admin'
import { useWatch } from "react-hook-form";
import { Datagrid, FormDataConsumer, DateField, DateInput, TextField, AutocompleteInput, NumberField, NumberInput, ReferenceInput, SelectField, SelectInput, PasswordInput, BooleanField, EmailField, BooleanInput, SimpleShowLayout, TopToolbar, ListButton, ShowButton, SimpleForm, TextInput} from 'react-admin';
import AddIcon from '@mui/icons-material/Add';
import AddManyLicensesDialog from 'components/AddManyLicensesDialog';

import moment from 'moment';
import licenseTypes from './licenseTypes';
import {PerpetualVersionList, PerpetualVersionChoices} from './perpetualVersions';
import { FormLabel } from '@mui/material';

import { Clear } from '@mui/icons-material';

const LicenseListActions = (props) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <TopToolbar>
                <CreateButton  />
                <Button
                    label="Add Many"
                    onClick={() => setOpen(true)}
                    startIcon={<AddIcon />}
                />
                <ExportButton />
            </TopToolbar>
            <AddManyLicensesDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};

const emailFilterToQuery = email => ({ email: email });
const productFilterToQuery = name => ({ name: name})

const licenseFilters = [
    <TextInput label="Email" source="email" defaultValue="" alwaysOn/>,
    <ReferenceInput source="productSkuId" reference="product-skus" alwaysOn>
        <AutocompleteInput
            optionText="name"
            suggestionLimit="20"
            filterToQuery={productFilterToQuery}
            fullWidth
        />
    </ReferenceInput>
];

export const LicenseList = () => (
    <List filters={licenseFilters} actions={<LicenseListActions />}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id"/>
            <ReferenceField source="userId" reference="users" label="User" />
            <ReferenceField source="productSkuId" reference="product-skus" label="ProductSku" />
            <TextField source="subject"/>
            <NumberField source="numSeats"/>
            <TextField source="durationIso"/>
            <DateField source="startDate"/>
            <DateField source="expirationDate"/>
            <BooleanField source="activated" FalseIcon={null}/>
            <BooleanField source="revoked" FalseIcon={null}/>
            <TextField source="token"/>
        </Datagrid>
    </List>
);

const LicenseShowActions = ({ basePath, data, resource }) => (
    <TopToolbar>
        <RevokeLicense record={data}/>
    </TopToolbar>
);

export const LicenseShow = (props) => (
    <Show {...props} actions={<LicenseShowActions/>}>
        <SimpleShowLayout>
            <TextField source="id"/>
            <ReferenceField source="userId" reference="users" label="User" />
            <ReferenceField source="productSkuId" reference="product-skus" label="ProductSku" />
            <TextField source="subject"/>
            <NumberField source="numSeats"/>
            <TextField source="durationIso"/>
            <DateField source="startDate"/>
            <DateField source="expirationDate"/>
            <BooleanField source="activated" FalseIcon={null}/>
            <BooleanField source="revoked" FalseIcon={null}/>
            <TextField source="token"/>
        </SimpleShowLayout>
    </Show>
);




export const LicenseCreate = (props) => {
    const transform = data => {
        let duration_iso = 'P';
        if (data.durationYears > 0) { duration_iso += `${data.durationYears}Y` }
        if (data.durationMonths > 0) { duration_iso += `${data.durationMonths}M` }
        if (data.durationDays > 0) { duration_iso += `${data.durationDays}D` }
        delete data.durationYears;
        delete data.durationMonths;
        delete data.durationDays;

        if (duration_iso != 'P') {  // no duration == perpetual
            data.durationIso = duration_iso;
        }
        return data
    };

    return (
        <Create {...props} transform={transform}>
            <SimpleForm>
                <ReferenceInput label="ProductSku" source="productSkuId" reference="product-skus">
                    <AutocompleteInput
                        optionText="name"
                        suggestionLimit="20"
                        filterToQuery={productFilterToQuery}
                        fullWidth
                    />
                </ReferenceInput>
                <TextInput source="subject" defaultValue="" fullWidth/>

                <ReferenceInput label="User" source="userId" reference="users">
                    <AutocompleteInput
                        optionText="email"
                        suggestionLimit="5"
                        filterToQuery={emailFilterToQuery}
                        fullWidth
                    />
                </ReferenceInput>
                <div>
                    <NumberInput source="durationYears" defaultValue={0} />
                    <NumberInput source="durationMonths" defaultValue={0} />
                    <NumberInput source="durationDays" defaultValue={0} />
                </div>
                
                <NumberInput source="numSeats" defaultValue={1}/>
                <BooleanInput label="Is this a Trial license?" source="isTrial" />
            </SimpleForm>
        </Create>
    );
}



const RevokeLicense = () => {
    const record = useRecordContext();
    const [update, { isPending }] = useUpdate()
    const notify = useNotify;

    const handleClick = () => {
        update('licenses',
            { id: record.id, data: { revoked: true } },
            {
                onSuccess: () => {
                    notify('Revoked license with id', record.id)
                },
                onError: (error) => {
                    notify('Error:', error)
                }
            });
    };

    return (
        <Fragment>
            <Button size="small" color="error" onClick={handleClick}><>Revoke</></Button>
        </Fragment>
    );
};